<template>
  <div>
    <change-language-header-table
      :current-language="currentLanguage"
      @change-language="changeLanguage"
    />
    <b-alert
      :show="Boolean(error)"
      variant="danger"
    >
      {{ error }}
    </b-alert>
    <b-data-table
      ref="refTable"
      :selectable="false"
      :table-columns="tableColumns"
      :fetch-list="fetchList"
    >
      <template #cell(actions)="data">
        <b-button
          v-if="$can('update', 'menu')"
          size="sm"
          :to="data.item.menuLink"
        >
          {{ $t('general.edit') }}
        </b-button>
        <b-button
          v-if="$can('delete', 'menu')"
          size="sm"
          variant="outline-danger"
          @click="deleteItem(data.item._id)"
        >
          {{ $t('general.delete') }}
        </b-button>
      </template>
    </b-data-table>
  </div>
</template>
<script>
import { BAlert, BButton } from 'bootstrap-vue'
import axios from '@axios'
import BDataTable from '@/components/BDataTable/index.vue'
import ChangeLanguageHeaderTable from '@/components/change-language-header-table.vue'
import useMenuList from './useMenuList'

export default {
  components: {
    BAlert, BButton, BDataTable, ChangeLanguageHeaderTable,
  },
  setup() { return useMenuList() },
  data() { return { error: '', deleting: false, disposed: false } },
  beforeDestroy() { this.disposed = true },
  methods: {
    changeLanguage(lang) { this.currentLanguage = lang; this.refTable.refetchData() },
    async deleteItem(id) {
      if (this.deleting || this.disposed || !this.$can('delete', 'menu')) return
      const lang = this.currentLanguage
      this.deleting = true
      this.error = ''
      try {
        const confirmed = await this.$bvModal.msgBoxConfirm(this.$t('general.areYouSure'))
        if (confirmed && !this.disposed && lang === this.currentLanguage && this.$can('delete', 'menu')) {
          await axios.delete(`/menus/${encodeURIComponent(id)}`)
          if (!this.disposed && lang === this.currentLanguage) this.refTable.refetchData()
        }
      } catch (error) {
        if (!this.disposed && lang === this.currentLanguage) this.error = this.$t('errors.deleteError')
      } finally { this.deleting = false }
    },
  },
}
</script>
